import { Routes } from '@angular/router';
import { RouterTools } from '@sol/components';
import { AsmRouteId } from '@asm/components-core/models/asm-route-id';
import { AsmAppRedirectGuard } from '@asm/components-platform-context/guards/asm-app-redirect.guard';

/** Shared account routes borrow the current app. */
export const routesAccount: Routes = [
  RouterTools.ofProfile(AsmRouteId.account_profile),
  {
    ...RouterTools.ofLazy(AsmRouteId.account_preferences, () =>
      import('@asm/components-platform-context/components/core/asm-preferences-page/asm-preferences-page.component').then(
        m => m.AsmPreferencesPageComponent,
      ),
    ),
    canActivate: [AsmAppRedirectGuard],
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
  },
  RouterTools.ofLogout(AsmRouteId.account_logout),
];
